module.exports = __webpack_public_path__ + "static/media/toggle-on.b63ea7d6.svg";